export default __webpack_public_path__ + "static/media/instagram_icon.9a2d1cdf.png";